"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndPolicyWorkflow = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var use_policy_by_uuid_1 = require("../../../hooks/use-policy-by-uuid");
var main_1 = require("./main");
function EndPolicyWorkflow(_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var policyUuid = _a.policyUuid, onSubmit = _a.onSubmit;
    var data = use_policy_by_uuid_1.usePolicyByUuid({ policyUuid: policyUuid }).data;
    if (!data) {
        return react_1.default.createElement(core_ui_1.Spinner, null);
    }
    var billingData = {
        premium: (_b = data.billing.premium) !== null && _b !== void 0 ? _b : 0,
        stateTax: (_c = data.billing.feesTaxes.surplusLinesStateTaxes) !== null && _c !== void 0 ? _c : 0,
        stateStampingFee: (_d = data.billing.feesTaxes.stampingFee) !== null && _d !== void 0 ? _d : 0,
        miscTaxesAndFees: (_e = data.billing.feesTaxes.miscTaxesFees) !== null && _e !== void 0 ? _e : 0,
        carrierPolicyFee: (_f = data.billing.feesTaxes.carrierFee) !== null && _f !== void 0 ? _f : 0,
        newfrontFee: (_g = data.billing.feesTaxes.miscAgencyBrokerFee) !== null && _g !== void 0 ? _g : 0,
        wholesaleFee: (_h = data.billing.feesTaxes.wholesaleFee) !== null && _h !== void 0 ? _h : 0,
    };
    return (react_1.default.createElement(main_1.EndPolicyMain, { billing: billingData, onSubmit: onSubmit, policyLegacyId: data.legacyId, policyUuid: data.uuid, accountUuid: data.accountUuid }));
}
exports.EndPolicyWorkflow = EndPolicyWorkflow;
